import SocialMediaIcons from "../components/SocialMediaIcons";

const Footer = () => {
  return (
    <footer className="py-6 px-4 backdrop-blur-md bg-white/10 border-t border-white/30 shadow-inner">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col items-center gap-4">
          <SocialMediaIcons />

          <div className="md:flex justify-between w-full text-center md:text-left px-4">
            <p className="font-playfair font-semibold text-xl text-white">
              GAURANSH GOEL
            </p>
            <p className="font-playfair text-md text-white opacity-80 mt-2 md:mt-0">
              MADE WITH 💌 and 🧠
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
